import React from "react";
import { X, ExternalLink } from "lucide-react";
import "./OneClubCase.css";
import ShareButton from "./components/ShareButton";

const GALLERY = [
  "/one-club-1.webp",
  "/one-club-2.webp",
  "/one-club-3.webp",
  "/one-club-4.webp",
  "/one-club-5.webp",
  "/one-club-6.webp"
];

export default function OneClubCase({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="oc-overlay" role="dialog" aria-modal="true">
      <ShareButton 
        className="oc-share" 
        title="ONE CLUB LA — AI Creative Challenge" 
        imagePath="/one-club-6.webp" 
        urlPath="/projects/one-club" 
      />
      <button className="oc-close" onClick={onClose} aria-label="Close case study">
        <X size={24} />
      </button>

      <div className="oc-scroll">
        <div className="oc-content">
          <header className="oc-hero">
            <div className="oc-badge">Live Event</div>
            <h1 className="oc-title">One Club AI Creative Challenge</h1>
            <p className="oc-subtitle">Head-to-head battle with LA's top 8 AI creators.</p>
            <p className="oc-meta">Los Angeles · Entropico Studio</p>
          </header>

          <div className="oc-video">
            <iframe 
              src="https://player.vimeo.com/video/1225149614?title=0&byline=0&portrait=0" 
              allow="autoplay; fullscreen; picture-in-picture" 
              allowFullScreen
              title="One Club AI Creative Challenge"
            ></iframe>
          </div>

          <section className="oc-prose">
            <p>
              The AI Creative Challenge is the ultimate face-off between the world's top AI Creators, and I was one chosen by the One Club for Creativity to compete. 
            </p>
            <p>
              It's a high-octane, bracketed esports battle where speed, creativity, and technical skill are tested under extreme pressure. This is more than a demo; it’s Human Creativity and AI as a spectator sport.
            </p>
            <p>
              In September 2026, the One Club for Creativity brought the competition to Los Angeles. The format was brutal: 8 of the city's top AI creators paired off in a live, bracket-style tournament. No prep, no pre-rendered assets.
            </p>
            <p>
              Competitors went head-to-head on stage in a timed 10-minute sprint, racing to fulfill a randomly selected challenge brief using the power of generative AI. We had to ideate, prompt, generate, edit, and deliver a finished video piece live on stage in front of an audience and a jury of creative directors from Google, Day One Agency, and Team One.
            </p>
            <p>
              First round? Create a commercial for bottled tap water - IN TEN MINUTES! Judges were split 50/50 and I eked out a win by a margin of 2% in the popular vote. 
            </p>
            <p>
              Second round? Make tourism commercial for the bottom of the ocean. This time we had 15 minutes. The Mariana piece was crafted in one of these rapid-fire rounds, a testament to what can be built when you have to make split-second decisions and trust your instincts - and your tools.
            </p>
            <p>
              It was a pressure cooker of execution, prompt mastery, and speed. To help me stay on task I built STORMY, a platform that helps usher you through the creative process. Try it yourself! Draw a brief and let it rip: <a href="https://creative-sprint-5.emergent.host/" target="_blank" rel="noopener noreferrer" style={{ color: "#f09073", textDecoration: "none" }}>https://creative-sprint-5.emergent.host/</a>
            </p>
            
            <a href="https://creativechallenge.ai/cities/la" target="_blank" rel="noopener noreferrer" className="oc-link">
              View official event page <ExternalLink size={14} />
            </a>
          </section>

          <section className="oc-gallery">
            {GALLERY.map((src, i) => (
              <figure key={i} className={`oc-fig ${i === 0 || i === 3 ? "span-2" : ""}`}>
                <img src={src} alt="One Club AI Creative Challenge event" />
              </figure>
            ))}
          </section>

        </div>
      </div>
    </div>
  );
}
